import { m as mOrig } from "@repo/localization/messages";
import { locale } from "./locale.svelte.js";

export const m = new Proxy(mOrig, {
    get(target, k) {
        const fn = Reflect.get(target, k);
        return (...args: unknown[]) => {
            void locale.current;
            return fn(...args);
        };
    },
});

export function resolveAuthError(error: string) {
    const code = error.replace(/ /g, "_").replace(/'/g, "").toUpperCase();
    return m[`better-auth.${code}` as keyof typeof mOrig & `better-auth.${string}`]?.();
}
